var map = {
	"./hd-suisse.jpg": 5354,
	"./mx3.jpg": 7693,
	"./play-srf.jpg": 6485,
	"./play-suisse.jpg": 3064,
	"./radio-international.jpg": 833,
	"./radio-rsi1.jpg": 1574,
	"./radio-rsi2.jpg": 7361,
	"./radio-rsi3.jpg": 3764,
	"./radio-rtr.jpg": 7373,
	"./radio-rts1.jpg": 1143,
	"./radio-rts2.jpg": 2472,
	"./radio-rts3.jpg": 6437,
	"./radio-rts4.jpg": 7198,
	"./radio-srf1.jpg": 5701,
	"./radio-srf2.jpg": 9450,
	"./radio-srf3.jpg": 6935,
	"./radio-srf4.jpg": 2092,
	"./rsi1.jpg": 8852,
	"./rsi2.jpg": 2547,
	"./rts-info.jpg": 9737,
	"./rts1.jpg": 5093,
	"./rts2.jpg": 4106,
	"./schweiz4.jpg": 6998,
	"./splus.jpg": 44,
	"./srf-info.jpg": 23,
	"./srf-musik-welle.jpg": 876,
	"./srf-virus.jpg": 6904,
	"./srf1.jpg": 6559,
	"./srf2.jpg": 8560,
	"./swiss-classic.jpg": 9669,
	"./swiss-jazz.jpg": 6690,
	"./swiss-pop.jpg": 9920,
	"./swiss-txt.jpg": 7981,
	"./swissinfo.jpg": 5246,
	"./xxx.jpg": 5875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 208;